import { render, staticRenderFns } from "./r4s-section.vue?vue&type=template&id=fae1564e&"
import script from "./r4s-section.vue?vue&type=script&lang=ts&"
export * from "./r4s-section.vue?vue&type=script&lang=ts&"
import style0 from "./r4s-section.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports